














































import { AdgroupFormData, CreateMode, AdgroupConfig, CampaignFormData, ShopType, shopStateMap } from '@tt4b/ttam-enums';
import { defineComponent, nextTick, computed, PropType, ref, toRefs, watch, onMounted } from '@vue/composition-api';
import TtamProductSourceShopAlert from './alert/index.vue';
import TtamProductSourceShop from './shop/index.vue';
import { useDataSource, useAlert, usePropsOperationList, useRules, useShopCheckbox } from './hooks';
import OperationList from '@/components/common/operation-list/index.vue';
import { useAdgroupMode, useStdAdgroupIs, useAdgroupCommonAlertInfo, useAllowlist } from '@tt4b/ttam-hooks';
import { trackEvent } from './../../../utils/index';
import { isValidId } from '@tt4b/ttam-utils';
import { i18n } from '@tt4b/ttam-i18n';
import TooltipInfo from '@/components/common/tooltip-info/index.vue';

const name = 'ttam-product-source-shop-compose';
export default defineComponent({
  name,
  components: {
    TtamProductSourceShop,
    TtamProductSourceShopAlert,
    OperationList,
    TooltipInfo,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
    isShowLabel: {
      type: Boolean,
      default: true,
    },
    // 错误字段map，初始化后的报错信息
    errorsMap: {
      type: Object as PropType<Record<string, string>>,
      default: () => ({}),
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      required: true,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const shopFormItemRef = ref(null);
    const shopRef = ref(null);
    const { addAdgroupAlertInfo } = useAdgroupCommonAlertInfo();
    const { adgroupData, createMode, adgroupConfig, campaignData } = toRefs(props);
    const { isPSA, isLiveAds, isStandardAds, isProductSales, isStandardAdsWithShop } = useStdAdgroupIs({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });
    const { isEdit, isCreate } = useAdgroupMode({ createMode });
    const { isShopOptionalWhite } = useAllowlist();
    // 是否展示checkbox
    const isShowCheckbox = computed(() => isLiveAds.value && isShopOptionalWhite.value);
    // checkbox的状态
    const { enableSelectShop, setEnableSelectShop } = useShopCheckbox();
    const canBeEmpty = computed(() => isShowCheckbox.value && !enableSelectShop.value);
    // 是否展示shop、shop alert模块
    const showShopModule = computed(() => !isShowCheckbox.value || enableSelectShop.value);
    // 记录反勾checkbox时，选中的shop，用于恢复
    const previousSelectedShop = ref();

    onMounted(() => {
      if (isShowCheckbox.value) {
        if (isCreate.value) {
          // 新建，默认打开checkbox
          return setEnableSelectShop(true);
        }
        // 编辑/复制，有选shop就默认给打开checkbox
        setEnableSelectShop(isValidId(adgroupData.value.shopId));
      }
    });
    const emptyShopData = {
      shopId: '',
      shopType: 0,
      shopAuthorizedBc: '',
      productPlatformId: '',
    };

    const selectedShop = computed({
      get: () => ({
        id: adgroupData.value.shopId,
        bc_id: adgroupData.value.shopAuthorizedBc,
        type: adgroupData.value.shopType,
        platform_id: adgroupData.value.productPlatformId,
      }),
      set: val => {
        let newVal = {
          shopId: val.id,
          shopType: val.type,
          shopAuthorizedBc: val.bc_id,
          productPlatformId: val.platform_id,
        };

        emit('change', newVal);
        emit('input', newVal);
        nextTick(() => {
          shopFormItemRef.value?.validate?.('custom');
          trackEvent('create_adgroup_shop_info', {
            shop_id: newVal.shopId,
            shop_type: newVal.shopType,
          });
        });
      },
    });

    watch(
      () => enableSelectShop.value,
      val => {
        // 把checkbox关闭的话，要清空shop数据
        if (!val) {
          previousSelectedShop.value = {
            shopId: selectedShop.value.id,
            shopType: selectedShop.value.type,
            shopAuthorizedBc: selectedShop.value.bc_id,
            productPlatformId: selectedShop.value.platform_id,
          };
          emit('change', emptyShopData);
          emit('input', emptyShopData);
        } else if (previousSelectedShop.value) {
          // 如果把checkbox重新选上，则把上一次选中的结果回调回去
          emit('change', previousSelectedShop.value);
          emit('input', previousSelectedShop.value);
        }
      },
    );

    const { isLoading, shopList, getShopList, hasLoaded } = useDataSource({ isPSA, isStandardAdsWithShop });
    // shop注销的场景 编辑场景下 vsa, lsa, psa 下闭环shop类型, shopList没有返回对应数据，或者shop状态为注销
    const shopHasDeactivatedSense = computed(() => {
      const shop = shopList.value?.find(
        item => item.id === selectedShop.value?.id && item.bc_id === selectedShop.value?.bc_id,
      );
      return (
        isEdit.value &&
        selectedShop.value.type === ShopType.ecommShop &&
        hasLoaded.value &&
        (!shop || shop?.shop_status === shopStateMap.withdraw)
      );
    });
    const { operationList } = usePropsOperationList({
      refresh: () => {
        getShopList();
        // 这样写可以有input框focus的效果，ued要求
        shopRef.value?.$refs?.inputRef?.focus?.();
      },
      isEdit,
      adgroupConfig,
    });
    const selectedShopData = computed(() => {
      const { id, bc_id } = selectedShop.value;
      return shopList.value.find(item => id === item.id && bc_id === item.bc_id);
    });
    const { storeManagerUrl, isAdmin: isShopAdmin, visible: visibleAlert } = useAlert({ shop: selectedShopData });
    const { shopValidator } = useRules({
      canBeEmpty,
    });
    watch(shopHasDeactivatedSense, val => {
      if (val) {
        // shop注销的场景洗显示提示
        addAdgroupAlertInfo({
          text: i18n.t('module_adgroup_shop_deactivated_edit_banner'),
          type: 'error',
          show: true,
          key: 'module_adgroup_shop_deactivated_edit_banner',
        });
      }
    });
    return {
      name,
      isEdit,
      shopFormItemRef,
      shopRef,
      isLoading,
      shopList,
      visibleAlert,
      isShopAdmin,
      storeManagerUrl,
      operationList,
      selectedShop,
      shopValidator,
      shopHasDeactivatedSense,
      enableSelectShop,
      setEnableSelectShop,
      isShowCheckbox,
      showShopModule,
    };
  },
});
